import { axios } from '@/utils/request'

const api = {
  configPre: '/admin.php/Config/pre',
  saveConfig: '/admin.php/Config/update',
  getIndex: '/admin.php/index/index/',
  getStatistics: '/admin.php/index/tongji/'
}

// 预加载
export function getPre (parameter) {
  return axios({
    url: api.configPre,
    method: 'get',
    params: parameter
  })
}
// 修改
export function saveConfig (data) {
  return axios({
    url: api.saveConfig,
    method: 'post',
    data: data
  })
}
// 获取首页数据
export function getIndex (parameter) {
  return axios({
    url: api.getIndex,
    method: 'get',
    params: parameter
  })
}
// 获取图标统计数据
export function getStatistics (parameter) {
  return axios({
    url: api.getStatistics,
    method: 'get',
    params: parameter
  })
}
